import { api } from 'common';

import { BlockDurationField } from '../../ConfigFields/Duration.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';
import { FormBlockFormFields } from '../Form/FormFields';

const FormV2Mode = api.FlowDefinition.FormV2Mode;

const modeOptions = [
  {
    value: FormV2Mode.AddOnly,
    label: 'No wait',
    subHeader: 'Block completes as soon as the formset is added to the patient.',
  },
  {
    value: FormV2Mode.AddAndWait,
    label: 'Wait for formset to reach any terminal status',
    subHeader:
      'Block waits for the formset to reach any terminal state (completed or expired). If the timeout value specified below is reached first, the block errors.',
  },
  {
    value: FormV2Mode.AddAndWaitForCompletion,
    label: 'Wait for formset to be completed',
    subHeader:
      'Block waits for the formset to be completed. If the timeout value specified below is reached first, the block errors.',
  },
];

export function FormV2BlockFormFields() {
  const { value: mode } = useSelectedNodeField<api.FlowDefinition.FormV2Mode>('config.mode');
  const resolvedMode = mode ?? FormV2Mode.AddAndWaitForCompletion;
  const waitsForFormSet = api.FlowDefinition.isFormV2WaitMode(resolvedMode);
  const timeoutLabel =
    resolvedMode === FormV2Mode.AddAndWaitForCompletion
      ? 'Form Set Completion Timeout'
      : 'Form Set Terminal State Timeout';

  return (
    <>
      <FormBlockFormFields mode="v2" />
      <BlockSelectField
        fieldName="config.mode"
        label="Mode"
        options={modeOptions}
        defaultValue={FormV2Mode.AddAndWaitForCompletion}
      />
      {waitsForFormSet && (
        <BlockDurationField
          fieldName="config.timeout"
          valueLabel={timeoutLabel}
          unitFieldNameSuffix="units"
          allowedUnits={Object.values(api.FlowDefinition.DurationUnits)}
          required
        />
      )}
    </>
  );
}
